module.exports = __webpack_public_path__ + "img/Winners Group.0c33da29.jpg";